export const OrderStatusERPEnum = {
  GENERATED: 'Generated',
  // PENDING: 'Pending',
  ERROR: 'GenerationFailed',
};

export const OrderStatusERPText = {
  [OrderStatusERPEnum.GENERATED]: 'Exportado',
  // [OrderStatusERPEnum.PENDING]: 'AGUARDANDO',
  [OrderStatusERPEnum.ERROR]: 'Erro',
};
